import { Link } from "react-router-dom";

const Footer = () => {
  const quickLinks = [
    { name: "Home", href: "/" },
    { name: "Services", href: "/services" },
    { name: "Training", href: "/courses" },
    { name: "About", href: "/about" },
    { name: "Contact", href: "/contact" }
  ];

  const trainingLinks = [
    { name: "AutoCAD APIs", href: "/courses/autocad-api" },
    { name: "SolidWorks APIs", href: "/courses/solidworks-api" },
    { name: "NX Open", href: "/courses/nx-open" },
    { name: "Eyeshot APIs", href: "/courses/eyeshot-api" },
    { name: "Inventor APIs", href: "/courses/inventor-api" },
    { name: "Rhino 3D APIs", href: "/courses/rhino3d-api" },
    { name: "CAD Automation", href: "/courses/cad-automation" }
  ];

  return (
    <footer
      data-testid="footer"
      className="bg-[#0F172A] text-slate-300 py-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="md:col-span-1 space-y-4">
            <Link
              to="/"
              data-testid="footer-logo"
              className="text-2xl font-bold text-white tracking-tight"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Codeyantra
            </Link>
            <p className="text-slate-400 leading-relaxed text-sm">
              Empowering engineers with industry-standard CAD automation and development solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3
              className="text-white font-semibold mb-4"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Training */}
          <div>
            <h3
              className="text-white font-semibold mb-4"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Training
            </h3>
            <ul className="space-y-3">
              {trainingLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3
              className="text-white font-semibold mb-4"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Contact
            </h3>
            <div className="space-y-3">
              <a
                href="mailto:contact@codeyantra.com"
                data-testid="footer-email"
                className="text-slate-400 hover:text-white transition-colors block text-sm"
              >
                contact@codeyantra.com
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-800 mt-12 pt-8 text-center">
          <p className="text-slate-500 text-sm">
            © 2018-2026 Codeyantra Technologies. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
